import * as React from 'react';
import AppBar from '@material-ui/core/AppBar';
import { Toolbar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { getLogoSrc } from '../../utils/logo';
import { useLocation } from 'react-router';
import { useMobile } from '../../hooks/useMobile';
import { useAuthContext } from '../../contexts/Auth';
import Link from '../misc/Link';
import themeInfo from '../../themes/themes';
import EmailSupport from '../BuildingBlocks/Misc/EmailSupport';

const useStyles = makeStyles((theme: any) => ({
  header: {
    backgroundColor: theme.palette.background.appBar,
    marginBottom: 0,
  },
  logo: { height: 50 },
  logoDiv: { padding: theme.spacing(0.5, 1) },
  supportLink: {
    color: theme.palette.primary.main,
    marginLeft: theme.spacing(3),
  },
}));

export default function MyAppBar() {
  const theme = process.env.REACT_APP_THEME;
  const mobile = useMobile();
  const location = useLocation();
  const classes = useStyles({ page: window.location.pathname });
  const logoSrc = getLogoSrc(themeInfo[theme], location.pathname, true);
  const { signedIn } = useAuthContext();

  return (
    !mobile && (
      <AppBar className={classes.header} color="inherit" elevation={0}>
        <Toolbar>
          {signedIn ? (
            <React.Fragment>
              <div style={{ flexGrow: 1 }} />
              {themeInfo[theme].displaySupportBanner && (
                <div className={classes.supportLink}>
                  <EmailSupport text="Support" />
                </div>
              )}
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Link href="/">
                <div className={classes.logoDiv}>
                  <img src={logoSrc} className={classes.logo} alt="logo" />
                </div>
              </Link>
              {themeInfo[theme].displaySupportBanner && (
                <div className={classes.supportLink}>
                  <EmailSupport inheritColor={true} text="Support" />
                </div>
              )}
            </React.Fragment>
          )}
        </Toolbar>
      </AppBar>
    )
  );
}
